// jshint module: true

import Component from './../../assets/scripts/component/component';
import throttle from 'lodash/throttle';

const component = 'gallery';
const selector = `.${component}`;

const fadeOutTransitionLength = 150;

const IMAGE_FIT_CONTAIN = 1;
const IMAGE_FIT_COVER = 2;

const imageFit = IMAGE_FIT_COVER;

class Gallery extends Component {

  constructor(name, element, options) {
    super(name, element, options);
  }

  init() {

    this.closeButton = this.element.querySelector('.button');
    this.wrapper = this.element.querySelector(`${selector}__wrapper`);

    document.addEventListener('click', this.onDocumentClick.bind(this), false);
    document.addEventListener('keydown', this.onDocumentKeyDown.bind(this), false);
    this.element.addEventListener('click', this.onGalleryClick.bind(this), true);
    window.addEventListener('resize', throttle(() => this.fitImage(false), 250, { trailing: true }));

  }

  onDocumentClick(event) {
    let element = event.target;

    if (!element) {
      return;
    }

    let target = element.getAttribute('target');

    if (target === document.body || target === document.documentElement) {
      return;
    }

    if (!target) {
      element = element.parentNode;
      target = element.getAttribute('target');
    }

    if (!target || target !== 'gallery') {
      return;
    }

    event.preventDefault();

    this.loadImage(element.href, element);

  }

  onDocumentKeyDown(event) {

    // If button it not escape, or gallery isn't open
    if (event.keyCode !== 27 || !this.element.classList.contains('is-open')) {
      return;
    }

    if (this.closeButton) {
      this.closeButton.click();
    }

  }

  onGalleryClick(event) {

    event.preventDefault();

    // right mouse button for image save-as
    if (event.which === 3) {
      return;
    }

    this.closeGallery();

  }

  loadImage(url, thumbnail) {

    thumbnail.classList.add('is-loading');

    let image = new Image();
    image.onload = () => {

      thumbnail.classList.remove('is-loading');
      image = null;

      this.showImage(url);

    };

    image.src = url;

  }

  showImage(url) {

    this.element.classList.add('is-open');
    this.wrapper.textContent = '';

    this.image = document.createElement('img');

    this.image.className = `${component}__image`;
    this.image.src = url;
    this.wrapper.appendChild(this.image);

    this.fitImage();

    document.documentElement.classList.add('prevent-scrolling');

  }

  fitImage() {

    if (!this.element.classList.contains('is-open') || !this.image || !this.wrapper) {
      return;
    }

    if (imageFit === IMAGE_FIT_CONTAIN) {
      this.image.style.width = '100%';
      this.image.style.height = 'auto';
    } else {
      this.image.style.width = 'auto';
      this.image.style.width = '100%';
    }

    this.image.style.minWidth = 'initial';
    this.image.style.minHeight = 'initial';

    const parentWidth = this.wrapper.offsetWidth;
    const parentHeight = this.wrapper.offsetHeight;

    let width = this.image.width;
    let height = this.image.height;

    // Set image to 2x dpi on hi-dpi devices, but only if the image is bigger then the screen.
    if (window.devicePixelRatio && window.devicePixelRatio >= 2 && this.image.width >= parentWidth && this.image.height >= parentHeight) {
      width /= 2;
      height /= 2;
    }

    this.image.style.minWidth = width + 'px';
    this.image.style.minHeight = height + 'px';

    if (imageFit === IMAGE_FIT_CONTAIN) {
      if (width < parentWidth && height >= parentHeight) { // horizontally lacking
        this.image.style.height = 'auto';
        this.image.style.width = parentWidth + 'px';
      } else if (height < parentHeight && width >= parentWidth) { // vertically lacking
        this.image.style.height = parentHeight + 'px';
        this.image.style.width = 'auto';
      } else { // both lacking
        this.image.style.height = 'auto';
        this.image.style.width = parentWidth + 'px';
      }
    } else {
      if (height < parentHeight && width >= parentWidth) { // vertically lacking
        this.image.style.height = parentHeight + 'px';
        this.image.style.width = 'auto';
      } else if (width < parentWidth && height >= parentHeight) { // horizontally lacking
        this.image.style.height = 'auto';
        this.image.style.width = parentWidth + 'px';
      } else {
        this.image.style.height = 'auto';
        this.image.style.width = parentWidth + 'px';
      }
    }

    this.centerImage();

  }

  centerImage() {
    const x = 50; // percentage
    const y = 50; // percentage

    if (!this.image || !this.wrapper) {
      return;
    }

    const distanceX = this.wrapper.scrollWidth - this.wrapper.offsetWidth;
    const distanceY = this.wrapper.scrollHeight - this.wrapper.offsetHeight;

    const scrollLeft = Math.round(distanceX / 2);;
    const scrollRight = Math.round(distanceY / 2);

    this.wrapper.scrollLeft = Math.round(distanceX / 2);
    this.wrapper.scrollTop = Math.round(distanceY / 2);

  }

  closeGallery() {
    let timeout;

    document.documentElement.classList.remove('prevent-scrolling');

    this.element.classList.add('has-been-open');
    this.element.classList.remove('is-open');

    window.clearTimeout(timeout);
    timeout = window.setTimeout(() => {

      this.element.classList.remove('has-been-open');

      if (!this.image) {
        return;
      }

      this.image.parentNode.removeChild(this.image);
      this.image = null;

    }, fadeOutTransitionLength);

  }

}

for (const element of document.querySelectorAll(selector)) {
  element.instance = new Gallery(component, element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/gallery/gallery.js